import React from "react";
import { HTMLChakraProps, Text, HStack, Image } from "@chakra-ui/react";
import { brandConfig, getColor } from "../brandConfig";

export const Logo = (props: HTMLChakraProps<"div">) => (
  <HStack spacing={1} align="center" {...props}>
    {/* Logo Image */}
    <Image
      src={brandConfig.logo.src}
      alt={brandConfig.logo.alt}
      h={{ base: "44px", md: "52px" }}
      objectFit="contain"
    />

    {/* Brand Name */}
    {/* <Text
      fontSize={{ base: "xl", md: "2xl" }}
      fontWeight="bold"
      color={getColor("primary")}
      letterSpacing="wide"
      display={{ base: "none", sm: "block" }}
    >
      {brandConfig.siteName}
    </Text> */}
  </HStack>
);

export default Logo;
